export const TuitionConstants = {
	PRODUCTS: {
		PRODUCT_TYPE_TUITION: {
			ID: 1
		}
	},
	pageTitles: {
		support: 'Support',
		history: 'History',
		profile: 'Profile',
		application: 'Application'
	},
	localStorageKeys: {
		CLIENT_DETAILS: 'ngStorage-client',
		CURRENT_USER: 'currentUser'
	},
	growthBook: {
		appHistoryPageFeatureKey: 'AppHistoryPage',
		appReviewPageFeatureKey: 'AppReviewPage'
	},
	topics: {
		clientAdminTopicId: '55719b8f-2327-e611-8c0f-005056994e22',
		messageExpertId: '4f91d01a-1d94-e511-9cab-005056994e22',
		loanRepayId: 'cadb5159-1c27-e611-8c0f-005056994e22'
	},
	SUPPORT_HISTORY: {
		COMMENTS_ADDED: 'commentsAdded'
	},
	ADD_COMMENT_BUTTON_NAME: 'Add Comment',
	PAYMENT_REQUEST_STATUS_DISPLAY: {
		110: 'Incomplete - Please Review',
		120: 'Submitted',
		425: 'Request in Review',
		450: 'Incomplete - Please Review',
		500: 'Payment Processing',
		900: 'Payment Sent',
		910: 'Request Cancelled',
		930: 'Request Denied'
	}
};
